export const PRODUCTS_SET = 'PRODUCTS_SET';
export const CATEGORIES_SET = 'CATEGORIES_SET';
